// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Qs from "qs";
import * as Json from "./Json.res.js";
import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function stringifyEncoder(primitive) {
  return encodeURIComponent(Stdlib_Option.getOr(Stdlib_Option.orElse(Stdlib_Option.orElse(Stdlib_Option.orElse(Stdlib_Option.map(Json.decodeString(primitive), string => `"` + string.replace(/"/g, `\\"`) + `"`), Stdlib_Option.map(Json.decodeBoolean(primitive), Pervasives.string_of_bool)), Stdlib_Option.map(Json.decodeNumber(primitive), number => number.toString())), Stdlib_Option.map(Json.decodeNull(primitive), param => "null")), ""));
}

function stringify(json) {
  return Qs.stringify(json, {
    encodeValuesOnly: true,
    encoder: stringifyEncoder
  });
}

function parseDecoder(string, param, param$1, type_) {
  if (type_ !== "value") {
    return Json.encodeString(string);
  }
  let decodedString = decodeURIComponent(string);
  switch (decodedString) {
    case "false" :
      return Json.encodeBoolean(false);
    case "null" :
      return null;
    case "true" :
      return Json.encodeBoolean(true);
    case "" :
    case "undefined" :
      return;
    default:
      if (decodedString.startsWith(`"`) && decodedString.endsWith(`"`)) {
        return Json.encodeString(decodedString.slice(1, -1).replace(/\\"/g, `"`));
      }
      if (!/^-?\d+(.\d+)?$/.test(string)) {
        return Json.encodeString(string);
      }
      let number = Stdlib_Float.fromString(string);
      if (number !== undefined) {
        return Json.encodeNumber(number);
      } else {
        return Json.encodeString(string);
      }
  }
}

function parse(query) {
  return Qs.parse(query, {
    ignoreQueryPrefix: true,
    decoder: parseDecoder
  });
}

export {
  stringifyEncoder,
  stringify,
  parseDecoder,
  parse,
}
/* qs Not a pure module */
